import type { ApiQuestion } from '../../../../internalTypes';
import type { StatementRow } from '../../../../types/shared';
import { resolveSubQuestionText } from './resolveStatementText';
import { mapAnswerLogic } from '../shared/mapAnswerLogic';

export function buildSimpleStatementRows(
  question: ApiQuestion,
  language?: string
): StatementRow[] {
  const rowSrc =
    (question.matrixRowQuestions?.length ?? 0) > 0
      ? question.matrixRowQuestions
      : question.childSurveyQuestions;

  if (rowSrc && rowSrc.length > 0) {
    return rowSrc
      .filter(sub => sub.id)
      .map(sub => {
        const answerLogic = mapAnswerLogic(sub.controlConfig?.displayLogic);
        return {
          id: sub.id!,
          statementText: resolveSubQuestionText(sub, language),
          ...(answerLogic ? { answerLogic } : {}),
        };
      });
  }

  return (question.answerDetails ?? [])
    .filter(a => !a.hidden && !a.additional?.isHintText)
    .map((a, i) => ({
      id: `row_${i}`,
      statementText: (language && a.translations?.[language]?.answerText) || a.answerText || '',
    }));
}
